import { useTranslation } from 'next-i18next';
import classnames from 'classnames';
import Link from '@/components/Link';

import styles from './logo.module.css';

interface LogoProps {
  className?: string,
  variant?: 'simple' | 'filled',
  type?: 'link' | 'block'
}

const LogoImage = ({ variant }: LogoProps) => {
  const { t } = useTranslation();
  const alt = t('main_company_name');

  return (
    <img
      className={styles.image}
      src={variant === 'filled' ? '/images/logo-filled.svg' : '/images/logo.svg'}
      alt={alt}
      width="100px"
      height="27px"
    />
  );
};

const Logo = ({ className, variant = 'simple', type = 'link' }: LogoProps) => {
  const { t } = useTranslation();

  if (type === 'link') return (
    <Link
      href="/"
      className={classnames(styles.link, className)}
      title={t('links.product')}
    >
      <LogoImage variant={variant} />
    </Link>
  );

  return (
    <span
      className={classnames(styles.link, className)}
      title={t('links.product')}
    >
      <LogoImage variant={variant} />
    </span>
  );
};

export default Logo;
